import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import DialogServices from '../../services/dialog.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';
import { ModalSymptomCheckInfoComponent } from '../modal-symptom-check-info/modal-symptom-check-info.component';

@Component({
	standalone: true,
	selector: 'pre-visit-history',
	templateUrl: './pre-visit-history.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, LoaderOverlayComponent, ListPagerComponent, FormsModule ]
})
export class PreVisitHistoryComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() tabs: any;
	@Input() activeTab: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.loading = true;
		this.vm.user = this.session.getSession().user;
		this.vm.preVisitTickets = null;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.loadPreVisits();
		
		this.vm.enumTranslations = {
			'NEW_HEALTH_PROBLEM': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_HEALTH_PROBLEM'),
			'PRESCRIPTION_RENEW_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.PRESCRIPTION_RENEW_REQUEST'),
			'HEALTH_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CERTIFICATE_REQUEST'),
			'HEALTH_CHECKUP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CHECKUP_REQUEST'),
			'VACCINATION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.VACCINATION_REQUEST'),
			'NEW_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_PRESCRIPTION_REQUEST'),
			'CHILD_RELATED_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHILD_RELATED_REQUEST'),
			'CHRONICALLY_ILL_VISIT_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_VISIT_REQUEST'),
			'SICK_LEAVE_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SICK_LEAVE_CERTIFICATE_REQUEST'),
			'FOLLOW_UP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.FOLLOW_UP_REQUEST'),
			'CHRONICALLY_ILL_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_PRESCRIPTION_REQUEST'),
			'REFERRAL_LETTER_TO_PSYCHOLOGIST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REFERRAL_LETTER_TO_PSYCHOLOGIST'),
			'MENTAL_HEALTH_CONSULTATION_REPORT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.MENTAL_HEALTH_CONSULTATION_REPORT'),
			'CREATED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CREATED'),
			'SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REFERRED_PRACTICE': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'PARTNER_SYSTEM_CONFIRMED_RECEIVED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REQUIRES_REGISTRATION': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REQUIRES_REGISTRATION'),
			'BOOKED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.BOOKED'),
			'COMPLETED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.COMPLETED'),
			'CANCELED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_CONFIRMED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'REJECTED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REJECTED'),
			'MEDIPOST_SEND_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'INTERNAL_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_PROCESSING_FAILED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_TRANSIENT_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR')
		};
		
		this.vm.cancelPreVisitTicket = this.cancelPreVisitTicket;
		this.vm.openSymptomCheckInfo = this.openSymptomCheckInfo;
	};
	
	ngOnDestroy() {
		
	};

	openSymptomCheckInfo(interviewId) {
		if (!interviewId) return;
		this.dialogServices.show({
			controller: ModalSymptomCheckInfoComponent,
			interviewId: interviewId, 
			preVisitTicketId: undefined
		});
	}
	
	cancelPreVisitTicket(ticket){
		var dialog = this.dialogServices.confirmation({
			content: this.angularFilterHelperService.translate('PreVisit.User_Tickets.Cancel_Confirmation')
		});
		dialog.afterClosed().subscribe((modalResponse) => {
			if (modalResponse && modalResponse.isAccepted) {
				this.restService.putPreVisitTicketCancel(ticket)
					.then((response) => {
						var foundIndex: any = this.vm.preVisitTickets.items.findIndex(function(x) {
							return x.id === response.id;
						});
						this.vm.preVisitTickets.items[foundIndex] = response;
					})
					.catch((error) => {
						console.log(error);
					});
			}
		});
	}
	
	loadPreVisits() {
		this.restService.findGetUserPreVisitTickets({
			pageSize: this.vm.pageSize,
			page: this.vm.currentPage
		}, {
			pageSize: this.vm.pageSize,
			page: this.vm.currentPage
		})
		.then((response) => {
			this.vm.preVisitTickets = response;
			for (var index in this.vm.preVisitTickets.items) {
				var ticket: any = this.vm.preVisitTickets.items[index];
				if (ticket.type === 'NEW_HEALTH_PROBLEM' && ticket.ticketDataList && ticket.ticketDataList.length > 0
				&& ticket.ticketDataList[0].config.fieldName === 'INFERMEDICA_INTERVIEW_ID') {
					ticket.infermedicaInterviewId = ticket.ticketDataList[0].content;
				}
			}
			this.vm.loading = false;
		})
		.catch((error) => {
			console.log(error);
			this.vm.loading = false;
		});
	}
	
}